export const production = true;

export const urls = {
  server: "https://racetoolserver.jagracingtools.com/",
  st: "https://strategyserver.jagracingtools.com/",
};
